import { AUTHORIZATION_HEADER } from '../../../../../src/authorization';
import { send } from '../../../../../src/network';
import { type DynamicConfig } from '../../../../../src/types/DynamicConfig';

export type { DynamicConfig };

type Params<T extends string> = {
  name: T;
};

export function getApiV2DynamicConfigsNameRequest<T extends string>(
  params: Params<T>
) {
  return {
    path: `/api/v2/dynamic_configs/${params.name}/`,
    method: 'GET',
    headers: new Headers({
      AUTHORIZATION: AUTHORIZATION_HEADER,
    }),
  } as const;
}

export async function getApiV2DynamicConfigsName<T extends string>(
  params: Params<T>
) {
  return await send<DynamicConfig<T>>(
    getApiV2DynamicConfigsNameRequest(params)
  );
}
